document.addEventListener('DOMContentLoaded', function () {
  const checkBtn = document.querySelector('.airlines-check-btn');
  const closeBtn = document.querySelector('.close-header svg');
  const airlinesMain = document.querySelector('.airlines-main');
  const searchInputWrapper = document.querySelector('.search-input-wrapper .field-wrapper');
  const searchInput = document.getElementById('search-input');
  const airlineItems = document.querySelectorAll('.airline-item');
  const errorDiv = document.querySelector('.search-error');
  let debounceTimeout;

  const normalize = str => str.trim().toLowerCase();

  // Open popup
  if (checkBtn && airlinesMain) {
    checkBtn.addEventListener('click', function () {
      checkBtn.classList.add('air-loading');
      airlinesMain.classList.add('show');

      setTimeout(() => {
        checkBtn.classList.remove('air-loading');
        airlinesMain.classList.add('active');
        document.body.classList.add('overflow-hidden');
      }, 1000);
    });
  }

  // Close popup
  if (closeBtn && airlinesMain) {
    closeBtn.addEventListener('click', function () {
      airlinesMain.classList.remove('show', 'active');
      document.body.classList.remove('overflow-hidden');
    });
  }

  // Search logic
  function performSearch() {
    const query = normalize(searchInput.value);
    let matchFound = false;

    // Reset error state
    errorDiv.classList.remove('show');
    searchInput.classList.remove('input-error');
    searchInput.style.borderColor = 'black';

    if (query === '') {
      airlineItems.forEach(item => item.style.display = 'flex');
    } else {
      airlineItems.forEach(item => {
        const airlineName = normalize(item.dataset.name);
        const isMatch = airlineName.includes(query);
        item.style.display = isMatch ? 'flex' : 'none';
        if (isMatch) matchFound = true;
      });

      if (!matchFound) {
        errorDiv.classList.add('show');
        searchInput.classList.add('input-error');
        searchInput.style.borderColor = 'red';

        // Keep all airlines visible if no match
        airlineItems.forEach(item => item.style.display = 'flex');
      }
    }

    searchInputWrapper.classList.remove('air-loading');
  }

  // Input event with debounce
  searchInput.addEventListener('input', () => {
    clearTimeout(debounceTimeout);
    searchInputWrapper.classList.add('air-loading');

    debounceTimeout = setTimeout(() => {
      performSearch();
    }, 1000);
  });
});
